import { useState, useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { Layout } from '@enterprise-ui/canvas-ui-react'
import { useAuth } from '@praxis/component-auth'
import { Header, SideNavigation } from 'item-component'
import { LogIn } from './LogIn'
import { MainRouter } from '../globalComponents/MainRouter'
import { fetchProductDetailsAndMenus } from '../globalServices/itemhubServices'
import getAppConfig from '../config/getAppConfig'
import { isItemHub } from '../globalUtills/common'

export const Main = () => {
  const auth = useAuth()
  const location = useLocation()
  const path =
    typeof window !== 'undefined' && window.location?.pathname
      ? window.location.pathname
      : location?.pathname || '/'
  const { isAuthenticated } = auth

  const [config, setConfig] = useState({})
  const [productMenusDetails, setProductMenusDetails] = useState([])

  useEffect(() => {
    getProductDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const fetchConfig = async () => {
      if (isItemHub) {
        const appConfig = await getAppConfig()
        setConfig(appConfig)
      }
    }
    fetchConfig()
  }, [])

  const getProductDetails = async () => {
    try {
      const menuDetails = await fetchProductDetailsAndMenus(auth)
      if (menuDetails?.message) {
        setProductMenusDetails([])
      } else {
        setProductMenusDetails(menuDetails)
      }
    } catch (error) {
      console.error('Error fetching product details and menus:', error)
      setProductMenusDetails([])
    }
  }

  if (isAuthenticated()) {
    return (
      <Layout
        theme="default"
        darkMode="false"
        data-testid="mainAuthenticatedLayout"
      >
        <Header useAuth={useAuth} isSupportVisible={true} />
        <SideNavigation
          className="side-navigation-panel"
          data-testid="item-app-sidenav-panel"
          appMenus={productMenusDetails}
          defaultmenurequired={true}
          isMinimized={false}
          itemHubApiKey={config?.itemHubAppService?.apiKey}
          clientApp={config?.itemHubAppService?.clientApp}
          LinkComponent={NavLink} // Pass your link component
          currentPath={path} // Pass the current path evaluated above
        />
        <MainRouter appMenus={productMenusDetails} />
      </Layout>
    )
  } else {
    return <LogIn />
  }
}
